import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  accommodationDetailsContainer: {
    width: '100%',
    padding: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: 8,
    marginBottom: 24,
    marginTop: 24,
    position: 'relative',
    backgroundColor: theme.palette.grey[200],
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }
  },
  accommodationDetailsContainerForChannel: {
    width: '100%',
    padding: 16,
    display: 'grid',
    gridTemplateColumns: '9fr 11fr 9fr 4fr 1fr',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: 8,
    marginBottom: 24,
    marginTop: 24,
    position: 'relative',
    backgroundColor: theme.palette.grey[200],
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }
  },
  pmsPasswordContainer: {
    display: 'flex',
    marginLeft: 30,
    marginRight: 50,
    alignItems: 'center',
    flex: 1,
    height: '100%',
    paddingTop: 50,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      padding: '30px 10px 10px'
    }
  },
  SwitchWithText: {
    position: 'relative',
    bottom: 45,
    [theme.breakpoints.down('sm')]: {
      top: 0,
      marginTop: 20,
      marginBottom: 16,
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }
  },
  switchContainer: {
    flex: 2,
    marginLeft: 10,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left',
      padding: '0 10px'
    }
  },
  switchContainerActive: {
    flex: 0.65,
    marginLeft: 10,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left',
      padding: '0 10px'
    }
  },
  switch: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  accordionCustom: {
    backgroundColor: theme.palette.grey[200],
    marginBottom: 10
  },
  dropDownIconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  skeletonContainer: {
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    marginTop: 24,
    borderRadius: 8
  },
  skeletonContainerDown: {
    display: 'flex',
    flexDirection: 'row'
  },
  skeletonUp: {
    width: '10%',
    height: 50
  },
  skeletonDownFirst: {
    width: '18%',
    height: 25,
    margin: '15px 0px 15px 0px'
  },
  skeletonDown: {
    width: '20%',
    height: 25,
    margin: '15px 25px 15px 25px'
  },
  buttonContainer: {
    width: 150
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  saveChangesButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  itemBox: {
    padding: 12,
    backgroundColor: theme.palette.grey[200],
    borderRadius: 12,
    transition: 'all 0.25s linear',
    position: 'relative',
    height: 'fit-content',
    boxSizing: 'border-box'
  },
  title: {
    marginBottom: 15,
    fontSize: 18,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  },
  codeMappingContianer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    },
    '& > div:first-child': {
      marginLeft: -11,
      marginBottom: -2
    },
    '& svg': {
      marginLeft: -55,
      marginRight: 65,
      marginBottom: -25
    },
    '&  div:last-child': {
      '& input': {
        height: '27px !important',
        borderRadius: '4px !important'
      },
      '& > div:first-child': {
        '& > div:first-child': {
          marginLeft: -12
        }
      }
    },
    '& div:nth-last-child(2)': {
      marginBottom: 0
    }
  },
  mappedCodeContainer: {
    height: 50
  }
}))

export default useStyles
